// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_489ed07","container":"_30532f3","title":"_57b2f5e","clubAvatar":"_54cede0","avatar":"_66148be","gamesOuterContainer":"_9617f35","gamesInnerContainer":"_4852b29"};